<template>
  <a :style="$parent.value === id ? activeStyle : {}" @click="onItemClicked" class="ly-tab-item">
    <div class="ly-tab-item-icon" v-if="$parent.fixBottom">
      <slot name="icon"></slot>
    </div>
    <div class="ly-tab-item-label">
      <slot></slot>
    </div>
  </a>
</template>

<script>
export default {
  name: 'LyTabItem',
  computed: {
    activeStyle() {
      return {
        color: this.$parent.activeColor
      }
    }
  },
  data() {
    return {
      id: (this.$parent.$children.length || 1) - 1
    }
  },
  methods: {
    onItemClicked() {
      this.$router.push({ path: '/courselist', query: { cp_id: this.id } })
      this.$parent.$emit('input', this.id)
    }
  }
}
</script>

<style>
.ly-tab-item {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  text-decoration: none;
  text-align: center;
}

.ly-tab-item-icon {
  margin: 0 auto 5px;
}
</style>



// WEBPACK FOOTER //
// src/components/Scroll/src/tab-item.vue